import { Constants } from './gradeSchemaConstants'
import { GradeSchema } from '../../../../model/apprenticeModuleGrade.model'

export const setGradeSchemas = (gradeSchemas: GradeSchema[]) => {
  return {
    type: Constants.SET_GRADE_SCHEMAS,
    payload: gradeSchemas,
  } as const
}

export const removeGradeSchemas = () => {
  return {
    type: Constants.REMOVE_GRADE_SCHEMAS,
  } as const
}